import Api from "./api";

class KeywordsApi {
    api = new Api()

    async getYandexWizardClasses() {
        return await this.api.get('/wizardClasses')
    }
}

export default new KeywordsApi();
